import React, { useState } from 'react';
import './Patents.css';

const patentsData = [
  // ==================== GRANTED PATENTS (8) ====================
  {
    id: 1,
    title: "A skin care preparation and process thereof",
    inventors: "Biman B Mandal and Jadi Praveen Kumar",
    patentNumber: "392521",
    applicationNumber: "201831026915",
    type: "Indian Patent",
    status: "Granted",
    year: "2018",
    grantDate: "18/07/2018",
    category: "Skincare & Cosmetics",
    description: "Novel silk-based skin care formulation with enhanced biocompatibility and therapeutic properties for improved skin health.",
    international: false,
  },
  {
    id: 2,
    title: "Development of silk based bioinks for 3D printing and uses thereof",
    inventors: "Biman B Mandal, Y.P. Singh, A. Bandyopadhyay, S. Mehrotra, J.C. Moses, B.K. Bhunia, G. Janani, D. Chouhan",
    patentNumber: "415089",
    applicationNumber: "201831038727",
    type: "Indian Patent",
    status: "Granted",
    year: "2022",
    grantDate: "21/12/2022",
    category: "3D Bioprinting",
    description: "Silk-based bioink formulations optimized for 3D bioprinting of tissue constructs with tunable mechanical and biological properties.",
    international: false
  },
  {
    id: 3,
    title: "Urokinase production through fiber reinforced silk scaffold using high density perfusion culture",
    inventors: "Biman B Mandal and G. Janani",
    patentNumber: "415174",
    applicationNumber: "201831024035",
    type: "Indian Patent",
    status: "Granted",
    year: "2022",
    grantDate: "21/12/2022",
    category: "Biotechnology",
    description: "Advanced bioreactor system utilizing fiber-reinforced silk scaffolds for enhanced production of therapeutic urokinase enzyme via high density perfusion culture.",
    international: false
  },
  {
    id: 4,
    title: "Electrospun Sericin/PVA mat as a prospective wound dressing material",
    inventors: "Biman B. Mandal and Sween Gilotra",
    patentNumber: "421397",
    applicationNumber: "638/KOL/2015",
    type: "Indian Patent",
    status: "Granted",
    year: "2015",
    category: "Wound Care",
    description: "Nanofibrous wound dressing combining silk sericin and polyvinyl alcohol (PVA) through electrospinning for enhanced wound healing and antimicrobial properties.",
    international: false
  },
  {
    id: 5,
    title: "Injectable nanocomposite silk hydrogel for targeted and controlled delivery of therapeutic agents",
    inventors: "Biman B Mandal and Ankit Gangrade",
    patentNumber: "438825",
    applicationNumber: "201931004799",
    type: "Indian Patent",
    status: "Granted",
    year: "2019",
    grantDate: "06/02/2019",
    category: "Drug Delivery",
    description: "Nanocomposite silk-based injectable hydrogel system designed for targeted and controlled release of therapeutic agents for minimally invasive treatments.",
    international: false
  },
  {
    id: 6,
    title: "Bi-layered porous silk vascular grafts and their uses thereof",
    inventors: "Biman B Mandal and Prerak Gupta",
    patentNumber: "537706",
    applicationNumber: "201931024432",
    type: "Indian Patent",
    status: "Granted",
    year: "2019",
    grantDate: "19/06/2019",
    category: "Cardiovascular",
    description: "Bi-layered porous silk-based vascular grafts engineered with optimized porosity and mechanical strength for vascular tissue replacement.",
    international: false
  },
  {
    id: 7,
    title: "Patterned silk film based vascular graft and its use thereof",
    inventors: "Biman B. Mandal and Prerak Gupta",
    patentNumber: "420608",
    applicationNumber: "1246/KOL/2015",
    type: "Indian Patent",
    status: "Granted",
    year: "2015",
    grantDate: "04/12/2015",
    category: "Cardiovascular",
    description: "Bioengineered vascular grafts with surface patterning on silk films for improved endothelialization and long-term patency.",
    international: false
  },
  {
    id: 8,
    title: "Silk hydrogels for treatment of burn wounds",
    inventors: "Biman B Mandal and Dimple Chouhan",
    patentNumber: "502017",
    applicationNumber: "201831022013",
    type: "Indian Patent",
    status: "Granted",
    year: "2018",
    grantDate: "12/06/2018",
    category: "Wound Care",
    description: "Novel silk-based hydrogel formulation specifically designed for enhanced burn wound healing with improved moisture retention and biocompatibility.",
    international: false
  },

  // ==================== APPLIED PATENTS (18) ====================
  {
    id: 9,
    title: "Multilayered silk scaffolds for meniscus tissue engineering",
    inventors: "Biman B. Mandal and David L. Kaplan",
    patentNumber: "PCT/US2011/039786",
    applicationNumber: "PCT/US2011/039786",
    type: "US Patent",
    status: "Filed",
    year: "2011",
    category: "Tissue Engineering",
    description: "Complex multilayered scaffold architecture mimicking native meniscus structure for regenerative orthopedic applications.",
    international: true
  },
  {
    id: 10,
    title: "Methods of producing and using silk microfibers",
    inventors: "Biman B. Mandal and David L. Kaplan",
    patentNumber: "WO 20150165092A1",
    applicationNumber: "WO 20150165092A1",
    type: "US Patent",
    status: "Filed",
    year: "2015",
    category: "Biomaterial Processing",
    description: "Innovative methods for producing silk microfibers with controlled properties for various biomedical and textile applications.",
    international: true
  },
  {
    id: 11,
    title: "Implantable Intervertebral disc devices and uses thereof",
    inventors: "Biman B. Mandal and David L. Kaplan",
    patentNumber: "WO 20140222152A1",
    applicationNumber: "WO 20140222152A1",
    type: "US Patent",
    status: "Filed",
    year: "2014",
    category: "Orthopedic Devices",
    description: "Biomimetic intervertebral disc replacement device using silk-based biomaterials for treating degenerative disc disease.",
    international: true
  },
  {
    id: 12,
    title: "Injectable silk hydrogel and its uses thereof",
    inventors: "Biman B Mandal",
    patentNumber: "31008502",
    applicationNumber: "31008502",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2020",
    category: "Biomedical Materials",
    description: "Minimally invasive injectable silk hydrogel system for tissue regeneration and therapeutic delivery applications.",
    international: false
  },
  {
    id: 13,
    title: "Nutritious Tissue Engineered Edible Meat and Methods of Production Thereof",
    inventors: "Biman B Mandal and Suvro Kanti Choudhury",
    patentNumber: "201831047999",
    applicationNumber: "201831047999",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2018",
    grantDate: "19/12/2018",
    category: "Cellular Agriculture",
    description: "Tissue engineering approach for producing nutritious edible cultured meat using scaffold-based cell culture methods.",
    international: false
  },
  {
    id: 14,
    title: "Antimicrobial coatings and preparation process thereof",
    inventors: "Biman B Mandal and Bibhas K. Bhunia",
    patentNumber: "202031014932",
    applicationNumber: "202031014932",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2020",
    grantDate: "03/04/2020",
    category: "Antimicrobial",
    description: "Novel antimicrobial coating formulations and their preparation processes for biomedical and healthcare applications.",
    international: false
  },
  {
    id: 15,
    title: "A porous injectable, freeze-dried hydrogel scaffold aiding dermal regeneration and process of preparation thereof",
    inventors: "Lissy K. Krishnan, Rashmi R., Dimple Chouhan and Biman B. Mandal",
    patentNumber: "201941022982",
    applicationNumber: "201941022982",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2019",
    category: "Wound Care",
    description: "Porous freeze-dried injectable hydrogel scaffold designed to aid dermal tissue regeneration with optimized microarchitecture.",
    international: false
  },
  {
    id: 16,
    title: "Hemostatic silk fibroin composite powder",
    inventors: "Biman B Mandal, Saptarshi Biswas and Bibhas K. Bhunia",
    patentNumber: "202031051948",
    applicationNumber: "202031051948",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2020",
    grantDate: "28/11/2020",
    category: "Wound Care",
    description: "Silk fibroin-based composite powder with rapid hemostatic properties for emergency wound management and surgical applications.",
    international: false
  },
  {
    id: 17,
    title: "Silk-Liver ECM composite for bioartificial liver",
    inventors: "Biman B. Mandal and Janani G.",
    patentNumber: "202031056432",
    applicationNumber: "202031056432",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2020",
    grantDate: "24/12/2020",
    category: "Organ Engineering",
    description: "Composite biomaterial combining silk and liver extracellular matrix (ECM) for development of bioartificial liver support systems.",
    international: false
  },
  {
    id: 18,
    title: "Silk Aloe composite for wound healing",
    inventors: "Biman B Mandal and Bibrita Bhar",
    patentNumber: "202131029685",
    applicationNumber: "202131029685",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2021",
    grantDate: "01/07/2021",
    category: "Wound Care",
    description: "Natural composite material combining silk fibroin and aloe vera for enhanced wound healing with anti-inflammatory and moisturizing properties.",
    international: false
  },
  {
    id: 19,
    title: "3D bioprinted osteochondral in vitro osteoarthritis model construct and applications thereof",
    inventors: "Biman B Mandal, Yogendra P. Singh, Joseph Christakiran Moses and Ashutosh Bandyopadhyay",
    patentNumber: "202131027358",
    applicationNumber: "202131027358",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2021",
    grantDate: "18/06/2021",
    category: "3D Bioprinting",
    description: "3D bioprinted osteochondral tissue construct serving as an in vitro osteoarthritis model for drug screening and disease study.",
    international: false
  },
  {
    id: 20,
    title: "3D bioprinted Vascularized Liver Lobule Model as Drug Screening Platform",
    inventors: "Biman B Mandal and G Janani",
    patentNumber: "202131050671",
    applicationNumber: "202131050671",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2021",
    grantDate: "03/11/2021",
    category: "3D Bioprinting",
    description: "Vascularized liver lobule model fabricated via 3D bioprinting for use as a high-throughput drug screening and hepatotoxicity testing platform.",
    international: false
  },
  {
    id: 21,
    title: "An in-vitro bone marrow construct mimicking the trabecular endosteum and its use thereof",
    inventors: "Biman B Mandal, Joseph Christakiran Moses and Sayanti Shome",
    patentNumber: "202131052636",
    applicationNumber: "202131052636",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2021",
    grantDate: "16/11/2021",
    category: "Tissue Engineering",
    description: "Biomimetic in-vitro bone marrow construct that recapitulates the trabecular endosteum microenvironment for hematological research.",
    international: false
  },
  {
    id: 22,
    title: "Silk hydrogel and a scaffold thereof for cancer therapy and modeling",
    inventors: "Biman B Mandal and Chitra Jaiswal",
    patentNumber: "202131045088",
    applicationNumber: "202131045088",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2021",
    grantDate: "05/10/2021",
    category: "Cancer Research",
    description: "Silk-based hydrogel scaffold system for cancer therapy applications and development of in-vitro tumor models.",
    international: false
  },
  {
    id: 23,
    title: "Silk bioactive nano-composite metal coating and its use thereof",
    inventors: "Biman B Mandal and Joseph Christakiran Moses",
    patentNumber: "202131061074",
    applicationNumber: "202131061074",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2021",
    grantDate: "27/12/2021",
    category: "Biomedical Materials",
    description: "Bioactive nano-composite coating combining silk with metallic nanoparticles for enhanced implant surface modification and biocompatibility.",
    international: false
  },
  {
    id: 24,
    title: "Wearable Electrotherapeutic Device for Wound Healing",
    inventors: "Biman B Mandal and Bibrita Bhar",
    patentNumber: "202431027630",
    applicationNumber: "202431027630",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2024",
    grantDate: "03/04/2024",
    category: "Medical Devices",
    description: "Wearable device integrating electrotherapy for accelerated wound healing with controlled electrical stimulation parameters.",
    international: false
  },
  {
    id: 25,
    title: "A Microfluidic Human Physio-Mimetic Liver Acinus Model",
    inventors: "Biman B. Mandal and Souradeep Dey",
    patentNumber: "202431039253",
    applicationNumber: "202431039253",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2024",
    grantDate: "20/05/2024",
    category: "Organ Engineering",
    description: "Microfluidic platform replicating the human liver acinus physiology for advanced drug metabolism studies and toxicity screening.",
    international: false
  },
  {
    id: 26,
    title: "Silk-based 3D bioprinted skin model for in vitro screening applications",
    inventors: "Biman B Mandal and Bibrita Bhar",
    patentNumber: "202431102555",
    applicationNumber: "202431102555",
    type: "Indian Patent Application",
    status: "Filed",
    year: "2024",
    grantDate: "24/12/2024",
    category: "3D Bioprinting",
    description: "3D bioprinted full-thickness skin model using silk-based bioinks for in vitro cosmetic and pharmaceutical screening applications.",
    international: false
  }
];

const Patents = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [expandedYears, setExpandedYears] = useState({});

  const categories = ['All', ...new Set(patentsData.map(p => p.category))];
  
  const stats = {
    total: patentsData.length,
    granted: patentsData.filter(p => p.status === 'Granted').length,
    filed: patentsData.filter(p => p.status === 'Filed').length,
    international: patentsData.filter(p => p.international).length,
  };

  const getFilteredPatents = () => {
    return patentsData.filter(patent => {
      const matchesCategory = selectedCategory === 'All' || patent.category === selectedCategory;
      return matchesCategory;
    });
  };

  const filteredPatents = getFilteredPatents();

  const patentsByYear = filteredPatents.reduce((acc, patent) => {
    const year = patent.year;
    if (!acc[year]) acc[year] = [];
    acc[year].push(patent);
    return acc;
  }, {});

  const toggleYear = (year) => {
    setExpandedYears(prev => ({
      ...prev,
      [year]: !prev[year]
    }));
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'Granted': return '#22c55e';
      case 'Filed': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const getStatusLabel = (status) => {
    switch(status) {
      case 'Granted': return 'Granted';
      case 'Filed': return 'Filed';
      default: return status;
    }
  };

  return (
    <div className="patent-page">
      <div className="patent-container">
        
        {/* Header Section */}
        <section className="patent-header">
          <h1 className="patent-title">Patents & Intellectual Property</h1>
          <p className="patent-subtitle">Explore our portfolio of innovation and technical achievements in biomedical research</p>
        </section>

        {/* Statistics Section */}
        <section className="patent-stats-bar">
          <div className="stat-item">
            <span className="stat-value">{stats.total}</span>
            <span className="stat-label">Total Patents</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.granted}</span>
            <span className="stat-label">Granted</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.filed}</span>
            <span className="stat-label">Filed/Pending</span>
          </div>
          <div className="stat-item">
            <span className="stat-value">{stats.international}</span>
            <span className="stat-label">International</span>
          </div>
        </section>

        {/* Controls Section */}
        <section className="patent-controls">
          <div className="filter-tabs">
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-tab ${selectedCategory === cat ? 'active' : ''}`}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </section>

        {/* Patents Display Section */}
        <section className="patents-list">
          {filteredPatents.length > 0 ? (
            Object.keys(patentsByYear).sort((a, b) => b - a).map(year => (
              <div key={year} className="year-section">
                <div 
                  className="year-header"
                  onClick={() => toggleYear(year)}
                >
                  <h3 className="year-title">
                    {year}
                  </h3>
                  <svg className={`year-toggle ${expandedYears[year] ? 'expanded' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M19 9l-7 7-7-7" /></svg>
                </div>
                {expandedYears[year] && (
                  <div className="year-patents">
                    {patentsByYear[year].map((patent) => (
                      <div key={patent.id} className="patent-card">
                        <div className="patent-content">
                          <h4 className="patent-paper-title">{patent.title}</h4>
                          <p className="patent-inventors">{patent.inventors}</p>
                          <p className="patent-description">{patent.description}</p>
                          <div className="patent-meta">
                            {patent.status === 'Granted' && (
                              <span className="patent-number-text">Patent No. {patent.patentNumber}</span>
                            )}
                            <span className="patent-number-text">App: {patent.applicationNumber}</span>
                            <span className="patent-type-badge">{patent.type}</span>
                            <span 
                              className="patent-status-badge"
                              style={{ backgroundColor: getStatusColor(patent.status) }}
                            >
                              {getStatusLabel(patent.status)}
                            </span>
                            {patent.international && (
                              <span className="patent-international"> International</span>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="no-results">
              <svg className="no-results-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <h3>No patents found</h3>
              <p>Try adjusting your category filter</p>
              <button
                className="reset-btn"
                onClick={() => setSelectedCategory('All')}
              >
                Reset Filters
              </button>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

export default Patents;